export default {
    DELETE_TOOLTIP: "Удалить"
};
